import request from "@/utils/request.js";
import {
  studyService,
  teachingPlatformApi,
  operateService,
  userService
} from "@/config/deploy.js";
/**
 * 获取用户课程列表
 * @param params
 * @returns {AxiosPromise}
 */
export function listUserCourse(params) {
  return request({
    url: studyService + "/app/course/listUserCourse",
    method: "post",
    data: params
  });
}
//获取用户课程列表-分页接口
export function pageUserCourse(params) {
  return request({
    url: studyService + "/app/course/pageUserCourse",
    method: "post",
    data: params
  });
}
/**
 * 获取教研课程包目录
 * @param params
 * @returns {AxiosPromise}
 */
export function listCourseChapter(params) {
  return request({
    url: studyService + "/app/course/listCourseChapter",
    method: "post",
    data: params
  });
}

/**
 * 获取试卷包列表页
 * @param params
 * @returns {AxiosPromise}
 */
export function listTestPaperByCoursePackage(params) {
  return request({
    url: studyService + "/app/course/listTestPaperByCoursePackage",
    method: "post",
    data: params
  });
}
/**
 * 获取课程介绍
 * @param params
 * @returns {AxiosPromise}
 */
export function getCourseIntroduce(params) {
  return request({
    url: teachingPlatformApi + "/app/course/getCourseIntroduce",
    method: "post",
    data: params
  });
}
/**
 * 课程已过期接口
 * @param params
 * @returns {AxiosPromise}
 */
export function getCourseValidityPastDueInfo(params) {
  return request({
    url: studyService + "/app/course/getCourseValidityPastDueInfo",
    method: "post",
    data: params
  });
}
/**
 * 课程订阅
 * @param params
 * @returns {AxiosPromise}
 */
export function subscibe(params) {
  return request({
    url: studyService + "/app/course/subscibe",
    method: "post",
    data: params
  });
}
/**
 * 课程收藏和取消收藏
 * @param params
 * @returns {AxiosPromise}
 */
export function collection(params) {
  return request({
    url: operateService + "/app/lines/collection",
    method: "post",
    data: params
  });
}

/**
 * 是否有课程兑换券
 * @param params
 * @returns {AxiosPromise}
 */
export function hashCourseCoupon(params) {
  return request({
    url: userService + "/user/coupon/hashCourseCoupon",
    method: "post",
    data: params
  });
}
